import { render, staticRenderFns } from "./AdvancedSettings.vue?vue&type=template&id=2435bd16&scoped=true&"
import script from "./AdvancedSettings.vue?vue&type=script&lang=js&"
export * from "./AdvancedSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedSettings.scss?vue&type=style&index=0&id=2435bd16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2435bd16",
  null
  
)

export default component.exports